module.exports = __webpack_public_path__ + "static/media/post-02.ee4b77e2.png";